<template>
  <div class="linexo light-theme error-message-box" role="alert">
    <LStatusBadge type="warning">
      <I18nT v-if="isMiniVariant" keypath="error.api_error_mini_view" tag="span" class="error-message-box__message">
        <template #link>
          <LLink
            class="error-message-box__link"
            :href="$t('error.api_error_mini_view_link_url')"
            target="_blank"
            rel="noopener noreferrer"
            :aria-label="$t('error.api_error_mini_view_link')"
            :title="$t('error.api_error_mini_view_link')"
          >
            {{ $t('error.api_error_mini_view_link') }}
          </LLink>
        </template>
      </I18nT>
      <span v-else class="error-message-box__message" :aria-label="errorMessage">{{ errorMessage }}</span>
    </LStatusBadge>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { I18nT, useI18n } from 'vue-i18n'
import { LLink, LStatusBadge } from '@wgg.hyve/hyve-ui-library'
import type { AErrorMessageProps } from './a-error-message-props'

const props = defineProps<AErrorMessageProps>()
const { t } = useI18n()

const errorMessage = computed<string>(() => props.message || t('error.check_settings'))
const isMiniVariant = computed(() => props.isMiniVariant === true)
</script>

<style lang="scss" scoped>
@import 'a-error-message-box';
</style>
